import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { categories } from "@/mocks/categories";
import { getAllVideos } from "@/utils/videoHelpers";

export default function AboutPage() {
  usePageMeta({
    title: "关于我们-91短视频",
    description:
      "了解91短视频：一个提供搞笑、娱乐、生活、美食等多类别热门短视频的观看与分享平台，致力于为年轻用户带来轻松愉快的短视频体验。",
    keywords: "91短视频,关于我们,短视频平台,视频分享",
  });

  const total = getAllVideos().length;

  return (
    <div className="w-full">
      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-information-line"></i>
            关于 91短视频
          </span>
          <h1 className="mt-4 max-w-3xl text-2xl font-bold leading-tight text-foreground-900 md:text-4xl">
            让每一个碎片时光，都有值得分享的短视频
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            91短视频是一个专注于热门短视频观看与分享的内容平台，面向热爱轻松娱乐的年轻大众与短视频爱好者。
            我们希望用简洁清爽的界面、丰富多样的内容，把搞笑、娱乐、生活、美食等精彩片段汇聚在一起，
            让你随时随地打开就能收获好心情。
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
          {[
            { icon: "ri-movie-2-line", value: `${total}+`, label: "示例视频内容" },
            { icon: "ri-layout-grid-line", value: `${categories.length}`, label: "核心内容分类" },
            { icon: "ri-team-line", value: "10万+", label: "示例活跃用户" },
            { icon: "ri-time-line", value: "7×24", label: "随时在线观看" },
          ].map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-background-200 bg-background-50 p-4 text-center md:p-5"
            >
              <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <p className="mt-3 text-xl font-bold text-foreground-900 md:text-2xl">{item.value}</p>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full bg-background-100 py-12 md:py-16">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <h2 className="text-xl font-bold text-foreground-900 md:text-2xl">我们的内容覆盖</h2>
          <p className="mt-2 text-sm text-foreground-500">
            四大核心分类，覆盖日常娱乐的各种场景
          </p>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
            {categories.map((category) => (
              <div
                key={category.slug}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${category.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-3 text-base font-bold text-foreground-900">
                  {category.name}短视频
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {category.description}
                </p>
                <Link
                  to={`/category/${category.slug}`}
                  className="mt-4 inline-flex cursor-pointer items-center gap-1 text-sm font-medium text-primary-600 transition hover:text-primary-700"
                >
                  进入分类
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <h2 className="text-xl font-bold text-foreground-900 md:text-2xl">关于本站</h2>
            <div className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
              <p>
                本站为「91短视频」主题的演示项目，旨在展示一个现代、清晰、内容丰富的短视频门户。
                页面中的视频、作者、评论、播放量等信息均为虚构示例，用于呈现完整的产品体验。
              </p>
              <p>
                视频播放区域为前端模拟占位，仅演示交互流程，不接入真实视频流；评论区为示范互动，
                不会向任何服务器提交数据；收藏功能基于浏览器本地存储实现，方便你体验个性化收藏。
              </p>
              <p>
                我们始终相信，好的内容应该让每个人都看得舒服。因此界面保持简洁，分类清晰，
                让找视频、看视频、分享视频都变得轻松自然。
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h2 className="flex items-center gap-2 text-base font-bold text-foreground-900">
              <i className="ri-feedback-line text-lg text-accent-500"></i>
              反馈与联系
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              如果你对91短视频有任何建议、内容合作或意见反馈，欢迎通过以下方式联系我们。
              你的每一条建议，都会让这个平台变得更好。
            </p>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-lg text-primary-500"></i>
                反馈邮箱：feedback@91short.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-lg text-primary-500"></i>
                客服时间：周一至周五 09:00 - 18:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-lg text-primary-500"></i>
                内容合作：cooperation@91short.example
              </li>
            </ul>
            <p className="mt-4 text-xs text-foreground-400">
              以上联系方式为演示信息，仅作展示用途。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-100 p-6 text-center md:flex-row md:text-left">
          <div>
            <h3 className="text-base font-bold text-foreground-900">准备好了吗？</h3>
            <p className="mt-1 text-sm text-foreground-500">
              回到首页，开始发现属于你的快乐短视频。
            </p>
          </div>
          <Link
            to="/"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            返回首页
          </Link>
        </div>
      </section>
    </div>
  );
}